import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0zm0 16.8c-4.301 0-7.8-3.499-7.8-7.8S4.699 1.2 9 1.2s7.8 3.499 7.8 7.8-3.499 7.8-7.8 7.8zm-.001-4.3a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm.605-8.961a2.863 2.863 0 0 0-2.397.574 2.834 2.834 0 0 0-1.05 2.206h1.2c0-.496.221-.961.607-1.275a1.64 1.64 0 0 1 1.396-.33 1.647 1.647 0 0 1 1.26 1.323 1.636 1.636 0 0 1-.458 1.443L9.013 8.629c-.263.265-.613.695-.613 1.382V11h1.2v-.989c0-.176.042-.312.262-.533L11.01 8.33a2.826 2.826 0 0 0 .794-2.488 2.835 2.835 0 0 0-2.2-2.303z" />
  </svg>
);

export default SvgComponent;
